import { createContext, useContext, useState } from 'react';

const SidebarContext = createContext();

export function SidebarProvider({ children }) {
  const [isSidebarShowing, setIsSidebarShowing] = useState(window.innerWidth > 1300);

  const toggleSidebar = () => setIsSidebarShowing(prev => !prev);

  return (
    <SidebarContext.Provider value={{ isSidebarShowing, setIsSidebarShowing, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
}

// Custom hook for convenience
export function useSidebarProvider() {
  return useContext(SidebarContext);
}